import axios from '@/plugins/axios'
import { MessageBox } from "element-ui"

export default {
    namespaced: true,

    state: {
        loading: false,
        agreements: [],
        agreement: {},
        types: {},
        showModal: false,
        modalAction: 'create',
        currentPage: 1,
        pageSize: 10,
        order: '',
    },

    mutations: {
        /**
         * @param state
         * @param bool
         */
        setLoader(state, bool) {
            state.loading = bool
        },

        /**
         * @param state
         * @param agreements
         */
        setAgreements(state, agreements) {
            state.agreements = agreements
        },

        /**
         *
         * @param state
         * @param agreement
         */
        setAgreement(state, agreement) {
            state.agreement = agreement
        },

        /**
         * @param state
         * @param bool
         */
        setModal(state, bool) {
            state.showModal = bool
        },

        /**
         * @param state
         * @param action
         */
        setModalAction(state, action) {
            state.modalAction = action
        },

        /**
         * @param state
         * @param page
         */
        setCurrentPage(state, page) {
            state.currentPage = page
        },

        /**
         * @param state
         * @param perPage
         */
        setPageSize(state, perPage) {
            state.pageSize = perPage
        },

        /**
         * @param state
         * @param order
         */
        setOrder(state, order) {
            state.order = order
        },

        /**
         *
         * @param state
         * @param types
         */
        setTypes(state, types) {
            state.types = types
        }
    },

    actions: {
        /**
         * @param commit
         * @param state
         * @returns {Promise<void>}
         */
        async getAgreements({ commit, state }) {
            try {
                commit('setLoader', true)

                const queryBuilder = state.order
                    ? `?${state.order}` + `&page=${state.currentPage}&perPage=${state.pageSize}`
                    : `?page=${state.currentPage}&perPage=${state.pageSize}`

                const { data } = await axios.admin.get('cms/pages' + queryBuilder)

                commit('setAgreements', data.pages)

            } catch (err) {
                console.error(err)
            } finally {
                commit('setLoader', false)
            }
        },

        /**
         * @param commit
         * @returns {Promise<void>}
         */
        async getPageTypes({ commit }) {
            try {
                const { data } = await axios.admin.get('cms/pages/types')
                commit('setTypes', data.types)
            } catch (err) {
                console.error(err)
            }
        },

        /**
         * @param dispatch
         * @param commit
         * @param state
         * @returns {Promise<void>}
         */
        async createOrUpdate({ dispatch, commit, state }) {
            try {
                if (!['create', 'update'].includes(state.modalAction)) return;

                if (state.modalAction === 'create') {
                    await MessageBox.confirm('You are trying to create a page that already exists, ' +
                        'by pressing create a new version of the existing page will be realized.',
                        'Confirmation', {
                        confirmButtonText: 'Create',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    })
                }
                const { data } = state.modalAction === 'create'
                    ? await axios.admin.post('cms/pages', state.agreement)
                    : await axios.admin.put(`cms/pages/${state.agreement.id}`, state.agreement)

                commit('setModal', false)
                dispatch('getAgreements')
            } catch (err) {
                console.log(err)
            }
        }
    }
}